var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHousehold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2752_1138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.2905 14.4531H2.82435C2.11882 14.4531 1.54688 13.8812 1.54688 13.1757V2.82435C1.54688 2.11882 2.11882 1.54688 2.82435 1.54688H8.29053C8.99605 1.54688 9.568 2.11882 9.568 2.82435V5.08469",
    stroke: "currentColor",
    strokeWidth: 1.09375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.72754 6.38208H6.50072",
    stroke: "currentColor",
    strokeWidth: 1.09375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86523 8.5603V10.3681",
    stroke: "currentColor",
    strokeWidth: 1.09375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86523 3.8064V4.20387",
    stroke: "currentColor",
    strokeWidth: 1.09375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5133 12.4507C11.3615 12.4507 12.0491 11.7631 12.0491 10.9149C12.0491 10.0667 11.3615 9.37915 10.5133 9.37915C9.66514 9.37915 8.97754 10.0667 8.97754 10.9149C8.97754 11.7631 9.66514 12.4507 10.5133 12.4507Z",
    stroke: "currentColor",
    strokeWidth: 1.09375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66064 7.4812H10.3024",
    stroke: "currentColor",
    strokeWidth: 1.09375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.3662,
    cy: 7.4812,
    r: 0.546875,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4529 10.1503V6.59036C14.4529 5.87127 13.8699 5.28833 13.1509 5.28833H7.87527C7.15618 5.28833 6.57324 5.87127 6.57324 6.59036V13.1511C6.57324 13.8702 7.15618 14.4531 7.87527 14.4531H13.1509C13.8699 14.4531 14.4529 13.8702 14.4529 13.1511V12.8847",
    stroke: "currentColor",
    strokeWidth: 1.09375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2752_1138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousehold);
export default __webpack_public_path__ + "static/media/household.13a14af1e16714596810e536504d9954.svg";
export { ForwardRef as ReactComponent };